module.exports = __webpack_public_path__ + "static/gallery17-7a188042db745c49a9b9d5aaa01adf89.jpg";